var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03125 0C1.63379 0 0.5 1.34375 0.5 3C0.5 3.94375 0.874414 4.83125 1.5125 5.4L12.9875 15.6C13.5887 16.1313 14.4113 16.1313 15.0125 15.6L26.4875 5.4C27.1256 4.83125 27.5 3.94375 27.5 3C27.5 1.34375 26.3662 0 24.9688 0H3.03125ZM0.5 7V20C0.5 22.2062 2.01348 24 3.875 24H24.125C25.9865 24 27.5 22.2062 27.5 20V7L16.025 17.2C14.8227 18.2688 13.1773 18.2688 11.975 17.2L0.5 7Z",
    fill: "#FB512D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeEmail);
export default __webpack_public_path__ + "static/media/orangeEmail.f4b3031ccc8a5effd6b479ce598f0983.svg";
export { ForwardRef as ReactComponent };